import { AllCommoditiesLoaded, MyCommoditiesLoaded, CommodityConfigurationLoaded, CommodityUpdated, MyCommodityUpdated, MyCommodityUpdatedFromStream } from './commodities.actions';
import Commodity from 'domain/commodity';
import { ReducerBase } from 'common/reducer';
import initialState from 'app/initialState';
import CommodityConfiguration from "./commodityConfiguration";

export class CommoditiesReducer extends ReducerBase<Commodity[]> {
	constructor() {
		super();
		this.addHandler(AllCommoditiesLoaded.EventName, this.handleCommoditiesLoaded);
		this.addHandler(CommodityUpdated.EventName, this.handleCommodityUpdated);
	}

	handleCommoditiesLoaded(state: Commodity[] = initialState.allCommodities, event: AllCommoditiesLoaded): Commodity[] {
		return event.commodities;
	}

	handleCommodityUpdated(state: Commodity[] = initialState.allCommodities, event: CommodityUpdated): Commodity[] {
		return state ? state.map(c => (c.id === event.commodity.id ? event.commodity : c)) : state;
	}

	handleDefault(state: Commodity[] = initialState.allCommodities) {
		return state;
	}
}

export class MyCommoditiesReducer extends ReducerBase<Commodity[]> {
	constructor() {
		super();
		this.addHandler(MyCommoditiesLoaded.EventName, this.handleCommoditiesLoaded);
		this.addHandler(MyCommodityUpdated.EventName, this.handleCommodityUpdated);
		this.addHandler(MyCommodityUpdatedFromStream.EventName, this.handleCommodityUpdatedFromStream);
	}

	handleCommoditiesLoaded(state: Commodity[] = initialState.myCommodities, event: MyCommoditiesLoaded): Commodity[] {
		return event.commodities;
	}

	handleCommodityUpdated(state: Commodity[] = initialState.myCommodities, event: MyCommodityUpdated): Commodity[] {
		return state ? state.map(c => (c.id === event.commodity.id ? event.commodity : c)) : state;
	}

	handleCommodityUpdatedFromStream(state: Commodity[] = initialState.myCommodities, event: MyCommodityUpdatedFromStream): Commodity[] {
		return state ? state.map(c => (c.id === event.update.id ? { 
				...c, 
				priceProtection: event.update.priceProtection
			} : c)) : state;
	}

	handleDefault(state: Commodity[] = initialState.myCommodities) {
		return state;
	}
}

export class CommodityConfigurationReducer extends ReducerBase<CommodityConfiguration> {
	constructor() {
		super();
		this.addHandler(CommodityConfigurationLoaded.EventName, this.handleConfigurationLoaded);
	}

	handleConfigurationLoaded(state: CommodityConfiguration = initialState.commodityConfiguration, event: CommodityConfigurationLoaded): CommodityConfiguration {
		return event.commodityConfiguration;
	}

	handleDefault(state: CommodityConfiguration = initialState.commodityConfiguration) {
		return state;
	}
}
